import * as React from "react"
import styled, { keyframes } from "@digits-css"
import { svgIconStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgDigitsLogo } from "@digits-shared/components/SVGIcons/digits/DigitsLogo.svg"
import colors from "@digits-shared/themes/colors"

/*
  STYLES
*/

const FADE_IN = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const FADE_IN_OUT = keyframes`
  0% {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.3;
  }
`

const LogoLoadingContainer = styled.div(`
  position: relative;
  width: var(--size);
  height: var(--size);
  opacity: 0;
  animation: ${FADE_IN} 300ms var(--delay, 250ms) ease-in-out
    forwards;
`)

const SvgDigitsLogoStyled = styled(
  SvgDigitsLogo,
  `
    --icon-color: var(--color, var(--module-loading-color, ${colors.secondary}));
    ${svgIconStyles("var(--icon-color)")}
    animation: ${FADE_IN_OUT} 1.4s infinite ease-in-out;
  `
)

/*
  INTERFACES
*/

interface LogoLoadingProps {
  size: string
  delay?: string
  color?: string
}

/*
  COMPONENTS
*/
export const LogoLoading = ({ color, size, delay }: LogoLoadingProps) => (
  <LogoLoadingContainer $size={size} $delay={delay}>
    <SvgDigitsLogoStyled $color={color} />
  </LogoLoadingContainer>
)
